module.exports = __webpack_public_path__ + "v1.0.0/img/lazyload_default.912f788.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lazyload/lazyload_default.png
// module id = tkOC
// module chunks = 1